import React from 'react'

import DaumPostcode, { Address } from 'react-daum-postcode'

interface PropsType {
	onSubmit: (res: Address) => void
}

export const AddressAutoComplete = (props: PropsType) => {
	const onCompletePost = (data: Address) => {
		props.onSubmit(data)
	}

	return <DaumPostcode autoClose onComplete={onCompletePost} />
}
